export default {
  userData: null
}